import { render, staticRenderFns } from "./BusinessSubSector.vue?vue&type=template&id=3357c999&"
import script from "./BusinessSubSector.vue?vue&type=script&lang=js&"
export * from "./BusinessSubSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports